/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import borders from "app/themes/theme-light/base/borders";
import boxShadows from "app/themes/theme-light/base/boxShadows";
import colors from "app/themes/theme-light/base/colors";

// Material Dashboard 2 PRO React TS Helper Functions
import linearGradient from "app/themes/theme-light/functions/linearGradient";
import pxToRem from "app/themes/theme-light/functions/pxToRem";

const { white, gradients, grey, transparent } = colors;
const { borderWidth } = borders;
const { md } = boxShadows;

// types
type Types = any;

const switchButton: Types = {
  defaultProps: {
    disableRipple: false
  },

  styleOverrides: {
    switchBase: {
      color: gradients.info.main,

      "&:hover": {
        backgroundColor: transparent.main
      },

      "&.Mui-checked": {
        color: gradients.info.main,

        "&:hover": {
          backgroundColor: transparent.main
        },

        "& .MuiSwitch-thumb": {
          borderColor: `${gradients.info.main} `
        },

        "& + .MuiSwitch-track": {
          backgroundColor: `${gradients.info.main} `,
          borderColor: `${gradients.info.main} `,
          opacity: 1
        }
      },

      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: "0.3 "
      },

      "&.Mui-focusVisible .MuiSwitch-thumb": {
        backgroundImage: linearGradient(gradients.info.main, gradients.info.state)
      }
    },

    thumb: {
      backgroundColor: white.main,
      boxShadow: md,
      border: `${borderWidth[1]} solid ${grey[400]}`
    },

    track: {
      width: pxToRem(32),
      height: pxToRem(15),
      backgroundColor: grey[400],
      border: `${borderWidth[1]} solid ${grey[400]}`,
      opacity: 1
    },

    checked: {}
  }
};

export default switchButton;
